import { CalendarDays } from 'lucide-react';

import { Link } from '@/components/ui/link';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { formatDate } from '@/utils/format/date';

import { ContractStatusBadge } from '../components/contract-status-badge';
import { ContractsQuery } from '../queries/contracts.query';

import { ContractsTableSkeletonRow } from './contracts-table-skeleton-row';

export function ContractsTable() {
  const contracts = ContractsQuery.useQuery();

  const filteredContracts = contracts.data?.contracts ?? [];

  return (
    <Table data-testid="contracts-table">
      <TableHead>
        <TableRow>
          <TableHeader className="!pl-3">Asset Name</TableHeader>
          <TableHeader>Start Date</TableHeader>
          <TableHeader>End Date</TableHeader>
          <TableHeader className="!pr-3">Status</TableHeader>
        </TableRow>
      </TableHead>
      <TableBody>
        {contracts.isLoading ? (
          Array.from({ length: 5 }).map((_, index) => (
            <ContractsTableSkeletonRow key={index} />
          ))
        ) : filteredContracts.length === 0 ? (
          <TableRow>
            <TableCell
              colSpan={4}
              className="p-8 text-center text-muted-foreground"
            >
              No subscriptions available.
            </TableCell>
          </TableRow>
        ) : (
          filteredContracts.map((contract) => (
            <TableRow key={contract.id} data-testid="contract-row">
              <TableCell className="!pl-3 font-medium">
                <Link to={`/asset/${contract.assetId}`}>
                  {contract.assetName}
                </Link>
              </TableCell>
              <TableCell>
                {contract.startDate ? (
                  <div className="flex items-center gap-2">
                    <CalendarDays className="size-4 text-muted-foreground" />
                    {formatDate(contract.startDate)}
                  </div>
                ) : (
                  <span className="text-muted-foreground">-</span>
                )}
              </TableCell>
              <TableCell>
                {contract.endDate ? (
                  <div className="flex items-center gap-2">
                    <CalendarDays className="size-4 text-muted-foreground" />
                    {formatDate(contract.endDate)}
                  </div>
                ) : (
                  <span className="text-muted-foreground">-</span>
                )}
              </TableCell>
              <TableCell className="!pr-3">
                <ContractStatusBadge status={contract.status} />
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
